import { ReactNode } from 'react'

interface SettingRowProps {
  label: string
  description?: string
  control: ReactNode
}

/**
 * Layout primitive for a single setting row inside a panel.
 * Label on the start, control on the end. Optional description under the label.
 */
export const SettingRow = ({ label, description, control }: SettingRowProps) => {
  return (
    <div className="flex items-start justify-between gap-4 py-3">
      <div className="min-w-0 flex-1">
        <div className="text-sm font-medium text-foreground">{label}</div>
        {description && (
          <div className="mt-1 text-xs text-muted-foreground">{description}</div>
        )}
      </div>
      <div className="shrink-0">{control}</div>
    </div>
  )
}
